import { alertTriangleIcon } from './alert-triangle';
import { allRelevantIcon } from './all-relevant';
import { averageCostIcon } from './average-cost';
import { checkIcon } from './check';
import { checkmarkIcon } from './checkmark';
import { costIcon } from './cost';
import { costsOfManualProcessingIcon } from './costs-of-manual-processing';
import { dataFileEditIcon } from './data-file-edit';
import { dislikeFilledIcon } from './dislike-filled';
import { dislikeIcon } from './dislike';
import { editViewOffIcon } from './edit-view-off';
import { estimatesIcon } from './estimates';
import { infoFullIcon } from './info-full';
import { irrelevantIcon } from './irrelevant';
import { lightIcon } from './light';
import { likeFilledIcon } from './like-filled';
import { likeIcon } from './like';
import { mapIcon } from './map';
import { meanDurationIcon } from './mean-duration';
import { pauseIcon } from './pause';
import { performanceDecrease1Icon } from './performance-decrease-1';
import { performanceIncreaseIcon } from './performance-increase';
import { removeIcon } from './remove';
import { resolvedIcon } from './resolved';
import { savingsPiggyDollarsIcon } from './savings-piggy-dollars';
import { starIcon } from './star';
import { timeAndCostIcon } from './time-and-cost';
import { undoIcon } from './undo';
import { variantsListIcon } from './variants-list';
import { variantsIcon } from './variants';
export const analyticsIcons = [alertTriangleIcon, allRelevantIcon, averageCostIcon, checkIcon, checkmarkIcon, costIcon, costsOfManualProcessingIcon, dataFileEditIcon, dislikeFilledIcon, dislikeIcon, editViewOffIcon, estimatesIcon, infoFullIcon, irrelevantIcon, lightIcon, likeFilledIcon, likeIcon, mapIcon, meanDurationIcon, pauseIcon, performanceDecrease1Icon, performanceIncreaseIcon, removeIcon, resolvedIcon, savingsPiggyDollarsIcon, starIcon, timeAndCostIcon, undoIcon, variantsListIcon, variantsIcon];
